import React from 'react';
import {ScenarioDTO} from 'hemwb-api';
import {Chip} from '@mui/material';
import {Column, TO_LOCALE_DATE_STRING_OPTIONS} from '../../../core/TableWithSortAndPagination';
import {fullName} from '../../../../store/user/utils';
import ExecutionStatus from '../../scenarioExecutionQueue/ExecutionStatus';
import {Collaborate16} from '@carbon/icons-react';

const ScenarioName: React.FC<{scenario: ScenarioDTO}> = ({scenario}) => (
  <>
    {scenario.name}
    {scenario.outdated && <Chip size="small" label="Outdated" style={{marginLeft: '0.5rem', height: '1.5rem'}} />}
  </>
);

const ScenarioSharing: React.FC<{scenario: ScenarioDTO}> = ({scenario}) => (
  <>
    {scenario.shared && (
      <div>
        <Collaborate16 />
        <span>Shared</span>
      </div>
    )}
  </>
);

export const DisplayScenarioName: React.FC<{scenario: ScenarioDTO}> = ({scenario}) => (
  <ScenarioName scenario={scenario} />
);

export const DisplayScenarioSharing: React.FC<{scenario: ScenarioDTO}> = ({scenario}) => (
  <ScenarioSharing scenario={scenario} />
);

export const getScenarioListGridColumns = (): Column<ScenarioDTO>[] => [
  {
    id: 'name',
    label: 'Instance Name',
    sortable: true,
    value: (scenario) => scenario.name,
    display: (scenario) => <DisplayScenarioName scenario={scenario} />,
    // classes: {th: styles.colNameHeading},
  },
  {
    id: 'createdBy',
    label: 'Creator',
    sortable: true,
    value: (scenario) => (scenario?.createdBy ? fullName(scenario?.createdBy) : ''),
  },
  {
    id: 'createdOn',
    label: 'Creation Date',
    sortable: true,
    value: (scenario) => scenario.createdOn,
    display: (scenario) => scenario.createdOn?.toLocaleDateString('en-US', TO_LOCALE_DATE_STRING_OPTIONS),
    // classes: {th: styles.colDateHeading},
  },
  {
    id: 'status',
    label: 'Status',
    sortable: true,
    value: (scenario) => scenario.status,
    display: ExecutionStatus,
    // classes: {th: styles.colStatusHeading},
  },
  {
    id: 'sharing',
    label: 'Sharing',
    sortable: false,
    value: (scenario) => scenario.status,
    display: (scenario) => <DisplayScenarioSharing scenario={scenario} />,
    // classes: {th: styles.colStatusHeading},
  },
];
